import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const LanguageContext = createContext();

export const translations = {
  id: {
    common: {
      loading: "Memuat...",
      cancel: "Batal",
      delete: "Hapus",
      save: "Simpan",
      edit: "Ubah",
      close: "Tutup",
      copy: "Salin",
      copied: "Tersalin",
      today: "Hari Ini",
      yesterday: "Kemarin",
      back: "Kembali",
    },
    sidebar: {
      platform: "PLATFORM",
      consultationHistory: "RIWAYAT KONSULTASI",
      newConsultation: "Sesi Konsultasi Baru",
      pinned: "Tersemat",
      others: "Lainnya",
      noSessions: "Belum ada sesi konsultasi",
      pinTooltip: "Sematkan (maks. 3)",
      unpinTooltip: "Lepas pin",
      pinnedBadge: "Disematkan",
      renameTooltip: "Ubah nama",
      deleteTooltip: "Hapus",
      deleteConfirm: "Apakah Anda yakin ingin menghapus sesi konsultasi ini?",
      themeToDark: "Beralih ke Dark Mode",
      themeToLight: "Beralih ke Light Mode",
      langSwitchTooltip: "Ganti ke Bahasa Inggris (Switch to English)",
      logout: "Keluar",
      poweredBy: "Didukung oleh Ahli Hukum Perpajakan: EnforceA (enforcea.com)",
      menuDashboard: "Dashboard",
      menuAdmin: "Admin Panel",
      menuUsers: "User Analytics",
      menuRlhf: "RLHF Analytics",
      collapseSidebar: "Ciutkan sidebar",
      expandSidebar: "Perluas sidebar",
    },
    chat: {
      aiSubtitle: "Konsultan Pajak AI",
      clearHistory: "Hapus riwayat chat",
      clearHistoryConfirm: "Hapus semua pesan dalam riwayat chat ini?",
      inputPlaceholder: "Ketik pesan atau drop/paste file...",
      dropTitle: "Drop file di sini",
      dropSubtitle: "PDF, DOCX, atau gambar",
      uploadTitle: "Upload dokumen sengketa (PDF/Gambar)",
      filesAttached: "file terlampir",
      removeAll: "Hapus Semua",
      removeFile: "Hapus file",
      copyMessage: "Salin pesan",
      editMessage: "Edit pesan",
      saveAndResend: "Kirim",
      cancelEdit: "Batal",
      resendMessage: "Kirim ulang pesan ini",
      creatingFile: "Membuat file...",
      downloadDocx: "Download .docx",
      downloadXml: "Download XML",
      welcomeMessage: "Selamat datang. Silakan sampaikan pertanyaan Anda seputar perpajakan.",
      serverError: "Gagal terhubung ke server.",
      errorParsing: "Maaf, error parsing jawaban.",
      errorFormat: "Maaf, format respons tidak sesuai. Silakan cek console untuk detail.",
    },
    feedback: {
      giveFeedback: "Beri umpan balik",
      copyResponse: "Salin respons",
      commentPlaceholder: "Koreksi atau komentar (opsional)...",
      submitting: "Mengirim...",
      submit: "Kirim Feedback",
      cancel: "Batal",
      tagLegal: "Akurasi hukum salah",
      tagCalc: "Kalkulasi salah",
      tagIrrelevant: "Tidak relevan",
      tagOutdated: "Informasi outdated",
      tagIncomplete: "Jawaban kurang lengkap",
      tagFormat: "Format / penyajian buruk",
      feedbackSent: "Terima kasih atas feedback Anda!",
    },
    thinking: {
      phase0: "Memahami pertanyaan...",
      phase2: "Mengklasifikasi kompleksitas...",
      phase4: "Mencari regulasi terkait di database...",
      phase8: "Menganalisis relevansi dokumen...",
      phase14: "Menyusun jawaban berdasarkan regulasi...",
      phase22: "Memverifikasi sitasi hukum...",
      phase30: "Melakukan review akhir...",
      phase40: "Masih memproses — pertanyaan ini butuh analisis mendalam...",
      phase60: "Masih bekerja — mohon tunggu sebentar...",
      thinkingTitle: "Proses berpikir Tacia",
      seeThinking: "Lihat proses berpikir Tacia",
      pipelineSteps: "langkah pipeline",
    },
    flowchart: {
      title: "Alur Proses & Kronologi Sengketa Pajak",
      tabFlowchart: "Flowchart",
      tabDiagram: "Diagram",
      tabText: "Teks",
      viewVisual: "Tampilan Flowchart Visual",
      viewMermaid: "Tampilan Diagram Vektor (Mermaid)",
      viewText: "Tampilan Teks Asli",
      switchHorizontal: "Beralih ke alur Horizontal",
      switchVertical: "Beralih ke alur Vertikal",
      horizontal: "Horizontal",
      vertical: "Vertikal",
      copyFlow: "Salin isi alur ke clipboard",
      nextStep: "Menuju tahap berikutnya",
      stageAudit: "Pemeriksaan",
      stageAssessment: "Ketetapan Pajak",
      stageObjection: "Keberatan",
      stageDecision: "Keputusan",
      stageAppeal: "Banding Pengadilan",
      stageDispute: "Materi Sengketa",
      stageTaxYear: "Tahun Pajak",
      stageProcess: "Proses",
    },
  },
  en: {
    common: {
      loading: "Loading...",
      cancel: "Cancel",
      delete: "Delete",
      save: "Save",
      edit: "Edit",
      close: "Close",
      copy: "Copy",
      copied: "Copied",
      today: "Today",
      yesterday: "Yesterday",
      back: "Back",
    },
    sidebar: {
      platform: "PLATFORM",
      consultationHistory: "CONSULTATION HISTORY",
      newConsultation: "New Consultation Session",
      pinned: "Pinned",
      others: "Others",
      noSessions: "No consultation sessions yet",
      pinTooltip: "Pin (max 3)",
      unpinTooltip: "Unpin",
      pinnedBadge: "Pinned",
      renameTooltip: "Rename",
      deleteTooltip: "Delete",
      deleteConfirm: "Are you sure you want to delete this consultation session?",
      themeToDark: "Switch to Dark Mode",
      themeToLight: "Switch to Light Mode",
      langSwitchTooltip: "Beralih ke Bahasa Indonesia (Switch to Indonesian)",
      logout: "Sign Out",
      poweredBy: "Powered by Tax Legal Experts: EnforceA (enforcea.com)",
      menuDashboard: "Dashboard",
      menuAdmin: "Admin Panel",
      menuUsers: "User Analytics",
      menuRlhf: "RLHF Analytics",
      collapseSidebar: "Collapse sidebar",
      expandSidebar: "Expand sidebar",
    },
    chat: {
      aiSubtitle: "AI Tax Consultant",
      clearHistory: "Clear chat history",
      clearHistoryConfirm: "Clear all messages in this chat history?",
      inputPlaceholder: "Type a message or drop/paste files...",
      dropTitle: "Drop files here",
      dropSubtitle: "PDF, DOCX, or images",
      uploadTitle: "Upload dispute documents (PDF/Images)",
      filesAttached: "files attached",
      removeAll: "Remove All",
      removeFile: "Remove file",
      copyMessage: "Copy message",
      editMessage: "Edit message",
      saveAndResend: "Send",
      cancelEdit: "Cancel",
      resendMessage: "Resend this message",
      creatingFile: "Generating file...",
      downloadDocx: "Download .docx",
      downloadXml: "Download XML",
      welcomeMessage: "Welcome. Please state your tax consultation questions or dispute matters.",
      serverError: "Failed to connect to the server.",
      errorParsing: "Sorry, error parsing response.",
      errorFormat: "Sorry, response format mismatch. Please check console for details.",
    },
    feedback: {
      giveFeedback: "Give feedback",
      copyResponse: "Copy response",
      commentPlaceholder: "Correction or feedback notes (optional)...",
      submitting: "Submitting...",
      submit: "Submit Feedback",
      cancel: "Cancel",
      tagLegal: "Incorrect legal accuracy",
      tagCalc: "Incorrect calculation",
      tagIrrelevant: "Irrelevant",
      tagOutdated: "Outdated information",
      tagIncomplete: "Incomplete answer",
      tagFormat: "Poor formatting / structure",
      feedbackSent: "Thank you for your feedback!",
    },
    thinking: {
      phase0: "Understanding query...",
      phase2: "Classifying complexity...",
      phase4: "Searching relevant tax regulations in database...",
      phase8: "Analyzing document relevance...",
      phase14: "Drafting response based on regulations...",
      phase22: "Verifying legal citations...",
      phase30: "Performing final review...",
      phase40: "Still processing — deep analysis in progress...",
      phase60: "Still working — please wait a moment...",
      thinkingTitle: "Tacia thinking process",
      seeThinking: "View Tacia thinking process",
      pipelineSteps: "pipeline steps",
    },
    flowchart: {
      title: "Tax Dispute Process & Chronological Timeline",
      tabFlowchart: "Flowchart",
      tabDiagram: "Diagram",
      tabText: "Text",
      viewVisual: "Visual Flowchart View",
      viewMermaid: "Vector Diagram View (Mermaid)",
      viewText: "Raw Text View",
      switchHorizontal: "Switch to Horizontal layout",
      switchVertical: "Switch to Vertical layout",
      horizontal: "Horizontal",
      vertical: "Vertical",
      copyFlow: "Copy timeline to clipboard",
      nextStep: "Proceed to next stage",
      stageAudit: "Tax Audit",
      stageAssessment: "Tax Assessment",
      stageObjection: "Objection",
      stageDecision: "Decision",
      stageAppeal: "Tax Appeal",
      stageDispute: "Dispute Matter",
      stageTaxYear: "Tax Year",
      stageProcess: "Process",
    },
  },
};

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => {
    return localStorage.getItem("tacia_language") || "id";
  });

  useEffect(() => {
    localStorage.setItem("tacia_language", language);
    document.documentElement.setAttribute("lang", language);
  }, [language]);

  const toggleLanguage = useCallback(() => {
    setLanguageState((prev) => (prev === "id" ? "en" : "id"));
  }, []);

  const setLanguage = useCallback((lang) => {
    if (lang === "id" || lang === "en") {
      setLanguageState(lang);
    }
  }, []);

  const t = useCallback(
    (keyPath, fallback = "") => {
      if (!keyPath) return fallback;
      const parts = keyPath.split(".");
      let current = translations[language] || translations.id;
      for (const part of parts) {
        if (current && typeof current === "object" && part in current) {
          current = current[part];
        } else {
          return fallback || keyPath;
        }
      }
      return typeof current === "string" ? current : fallback || keyPath;
    },
    [language]
  );

  return (
    <LanguageContext.Provider
      value={{
        language,
        isIndonesian: language === "id",
        isEnglish: language === "en",
        toggleLanguage,
        setLanguage,
        t,
        translations: translations[language] || translations.id,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    return {
      language: "id",
      isIndonesian: true,
      isEnglish: false,
      toggleLanguage: () => {},
      setLanguage: () => {},
      t: (keyPath, fallback = "") => fallback || keyPath,
      translations: translations.id,
    };
  }
  return context;
}
